import { takeEvery, call, put, select } from 'redux-saga/effects'

import TEACHER_GUIDE from 'app/constants/teacher-guide.constants'
import { isEmpty } from 'app/utils/array'

import {
  TEACHER_GUIDE_ACTIONS,
  TeacherGuideActionsCreators,
} from 'app/store/actions/teacher-guide.actions'
import { getTeacherGuideData } from 'app/services/api/data.service'
import { ReduxSagaAction } from 'app/types/store.types'

function* getTeacherGuideDataSaga({
  payload: id,
}: ReduxSagaAction<keyof typeof TEACHER_GUIDE>): Generator {
  let action
  try {
    const teacherGuideKey = TEACHER_GUIDE[id]
    action = TeacherGuideActionsCreators[id]

    let data = yield select((state) => state.teacherGuide[teacherGuideKey].data)

    if (isEmpty(data)) {
      data = yield call(getTeacherGuideData, `${teacherGuideKey}.json`)
    }

    yield put(action.success({ data }))
  } catch (error) {
    if (action) {
      yield put(action.failure({ error }))
    }
  }
}

export default function* watchTeacherGuideActions() {
  yield takeEvery(
    [...Object.values(TEACHER_GUIDE_ACTIONS).map((action) => action.REQUEST)],
    getTeacherGuideDataSaga
  )
}
